import { SUPER_ADMIN_ROLE, hasAccess } from '@/libs/userAbility/userAbilityChecker';
import {BLACKLIST_DEVICES_LIST} from "@/libs/userAbility/userAbilityRoles/roleBlackListDevices";
import {ACCESS_LEVEL_LIST} from "@/libs/userAbility/userAbilityRoles/rolesAccessLevel";
import {CAMPAIGN_LIST} from "@/libs/userAbility/userAbilityRoles/rolesCampaign";
import {CITY_LIST} from "@/libs/userAbility/userAbilityRoles/rolesCity";
import { COUNTRY_LIST } from '@/libs/userAbility/userAbilityRoles/rolesCountry';
import {DATA_CENTER_LIST} from "@/libs/userAbility/userAbilityRoles/rolesDataCenter";
import {LANDING_DOMAINS_LIST} from "@/libs/userAbility/userAbilityRoles/rolesLandingDomains";
import {MASTER_HOST_LIST} from "@/libs/userAbility/userAbilityRoles/rolesMasterHost";
import { RECEIPTS_LIST } from '@/libs/userAbility/userAbilityRoles/rolesReceipts';
import { STATISTICS_LIST } from '@/libs/userAbility/userAbilityRoles/rolesStatistics';
import {TICKETS_LIST} from "@/libs/userAbility/userAbilityRoles/rolesTickets";
import {USER_LIST} from "@/libs/userAbility/userAbilityRoles/rolesUser";
import {USERS_GROUP_LIST} from "@/libs/userAbility/userAbilityRoles/rolesUsersGroup";
import {VPN_LIST} from "@/libs/userAbility/userAbilityRoles/rolesVpn";


import {ROLE_MEDIA_BUYER, ROLE_USER} from "@/libs/userAbility/userAbilityRoles/defaultRoles";
import { REBILLS_LIST } from './libs/userAbility/userAbilityRoles/roleRebills';
import { GENERATED_LEAD_REPORT_LIST } from './libs/userAbility/userAbilityRoles/generatedLeadReport';

const filteredNav = (paramItems: any, paramRoles: any): any => {
    return paramItems.filter((el: any) => {
        if (el.children) {
            el.children = filteredNav(el.children, paramRoles);
            return el.children.length;
        }
        if (el.public) {
            return true;
        }
        return hasAccess(el.accessLevel, paramRoles);
    });
};

const items = () => [
    {
        title: true,
        name: 'Astrology',
        accessLevel: ROLE_USER
    },
    {
        name: 'Biorhythms',
        url: '/biorhythms',
        icon: 'fa fa-asterisk',
        accessLevel: USER_LIST,
        children: [
            {
                name: 'List',
                url: '/biorhythms/biorhythms-list',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            },
            {
                name: 'Types',
                url: '/biorhythms/biorhythm-types',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            }
        ]
    },
    {
        name: 'Numerology',
        url: '/numerology',
        icon: 'fa fa-compass',
        accessLevel: USER_LIST,
        children: [
            {
                name: 'List',
                url: '/numerology/numerology-list',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            },
            {
                name: 'Types',
                url: '/numerology/numerology-types',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            }
        ]
    },
    {
        name: 'App configs',
        url: '/app_configs',
        icon: 'fa fa-cog',
    },
    {
        name: 'Another Life',
        url: '/another-life',
        icon: 'fa fa-diamond',
        accessLevel: USER_LIST,
        children: [
            {
                name: 'Model',
                url: '/another-life/another-life-model',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            },
            {
                name: 'Result',
                url: '/another-life/another-life-result',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            }
        ]
    },
    {
        name: 'Famous Baby',
        url: '/famous-baby',
        icon: 'fa fa-share-alt',
        accessLevel: USER_LIST,
        children: [
            {
                name: 'Model',
                url: '/famous-baby/famous-baby-model',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            },
            {
                name: 'Result',
                url: '/famous-baby/famous-baby-result',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            }
        ]
    },
    {
        name: 'Horoscopes',
        url: '/horoscopes',
        icon: 'fa fa-feed',
        accessLevel: USER_LIST,
        children: [
            {
                name: 'Daily',
                url: '/horoscopes/dailies',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            },
            {
                name: 'Monthly',
                url: '/horoscopes/monthlies',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            },
            {
                name: 'Annual',
                url: '/horoscopes/annuals',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            },
            {
                name: 'Keywords',
                url: '/horoscopes/keywords',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            },
        ]
    },
    {
        name: 'Meditation',
        url: '/meditation',
        icon: 'fa fa-play-circle',
        accessLevel: USER_LIST,
        children: [
            {
                name: 'Categories',
                url: '/meditation/meditation-categories',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            },
            {
                name: 'Resources',
                url: '/meditation/meditation-resources',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            }
        ]
    },
    {
        name: 'BirthChart',
        url: '/birth-chart',
        icon: 'fa fa-birthday-cake',
        accessLevel: USER_LIST,
        children: [
            {
                name: 'House Description',
                url: '/birth-chart/house-description',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            },
            {
                name: 'Planet Description',
                url: '/birth-chart/planet-description',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            },
            {
                name: 'Planet in Sign',
                url: '/birth-chart/planet-in-sign',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            }
        ]
    },
    {
        name: 'Tarot',
        url: '/tarot',
        icon: 'fa fa-hourglass-start',
        accessLevel: USER_LIST,
        children: [
            {
                name: 'Cards',
                url: '/tarot/tarot-cards',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            },
            {
                name: 'Fortunes',
                url: '/tarot/tarot-fortunes',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            },
            {
                name: 'Results',
                url: '/tarot/tarot-results',
                icon: 'fa fa-info',
                accessLevel: USER_LIST
            }
        ]
    },
    {
        name: 'Compatibilities',
        url: '/compatibilities',
        icon: 'fa fa-heart',
        accessLevel: USER_LIST,
    },
    {
        name: 'Compatibility Score',
        url: '/compatibility-score-description',
        icon: 'fa fa-lightbulb-o',
        accessLevel: USER_LIST,
    },
    {
        name: 'Sign Relationship',
        url: '/sign-relationship',
        icon: 'fa fa-rocket',
        accessLevel: USER_LIST,
    },
    {
        name: 'Palm Lines',
        icon: 'fa fa-hand-spock-o',
        url: '/palm-lines',
        accessLevel: USER_LIST,
    },
    {
        name: 'Cookies',
        icon: 'fa fa-cubes',
        url: '/cookies',
        accessLevel: USER_LIST,
    },
    {
        name: 'Future Baby',
        icon: 'fa fa-street-view',
        url: '/future-baby',
        accessLevel: USER_LIST,
    },
    {
        name: 'Moods',
        icon: 'fa fa-sun-o',
        url: '/moods',
        accessLevel: USER_LIST,
    },
    {
        name: 'Moon Signs',
        icon: 'fa fa-moon-o',
        url: '/moon-signs',
        accessLevel: USER_LIST,
    },
    {
        name: 'Yes or No',
        icon: 'fa fa-question',
        url: '/yes-or-no',
        accessLevel: USER_LIST,
    },
    {
        name: 'Astrogical Signs',
        icon: 'fa fa-star-o',
        url: '/astrogical-signs',
        accessLevel: USER_LIST,
    },
    {
        name: 'Astro Events',
        icon: 'fa fa-calendar',
        url: '/astro-events',
        accessLevel: USER_LIST,
    },
    {
        title: true,
        name: 'Astrology subscriptions',
        accessLevel: ROLE_USER
    },
    {
        name: 'Sources',
        url: '/subscriptions/traffic-sources',
        icon: 'icon-energy',
        accessLevel: USER_LIST,
    },
    {
        name: 'Landings',
        url: '/subscriptions/landings',
        icon: 'icon-layers',
        accessLevel: USER_LIST,
    },
    {
        name: 'Campaigns',
        url: '/subscriptions/campaigns',
        icon: 'icon-speedometer',
        accessLevel: CAMPAIGN_LIST
    },
    {
        name: 'Statistics',
        url: '/subscriptions/statistics',
        icon: 'icon-chart',
        accessLevel: STATISTICS_LIST
    },
    {
        name: 'Tariffs',
        icon: 'fa fa-info',
        url: '/subscriptions/tariffs',
        accessLevel: USER_LIST,
    },
    {
        name: 'Client Apps',
        icon: 'icon-list',
        url: '/subscriptions/client-apps',
        accessLevel: USER_LIST,
    },
    {
        title: true,
        name: 'Main',
        accessLevel: ROLE_USER
    },
    {
        name: 'Dashboard',
        icon: 'icon-speedometer',
        url: '/dashboard',
        accessLevel: VPN_LIST
    },
    {
        name: 'VPNs',
        icon: 'fa fa-sitemap',
        url: '/vpns',
        accessLevel: VPN_LIST
    },
    {
        name: 'Master Server',
        url: '/master-server',
        icon: 'fa fa-certificate',
        accessLevel: MASTER_HOST_LIST
    },
    {
        name: 'Lead Report',
        url: '/generated-lead-report',
        icon: 'fa fa-table',
        accessLevel: GENERATED_LEAD_REPORT_LIST
    },
    
    {
        name: 'Users',
        url: '/users',
        icon: 'icon-user',
        accessLevel: USER_LIST,
        children: [
            {
                name: 'List',
                url: '/users',
                icon: 'icon-list',
                accessLevel: USER_LIST
            },
            {
                name: 'Groups',
                url: '/users-groups',
                icon: 'icon-people',
                accessLevel: USERS_GROUP_LIST
            }
        ]
    },
    {
        divider: true,
        accessLevel: ROLE_USER
    },
    {
        title: true,
        name: 'Finance',
        accessLevel: ROLE_USER
    },
    {
        name: 'Tickets',
        icon: 'fa fa-support',
        url: '/tickets',
        accessLevel: TICKETS_LIST
    },
    {
        name: 'Receipts',
        icon: 'fa fa-ticket',
        url: '/receipts',
        accessLevel: RECEIPTS_LIST
    },
    {
        name: 'Tariffs',
        icon: 'fa fa-info',
        url: '/tariffs',
        accessLevel: USER_LIST,
    },
    {
        divider: true
    },
    {
        title: true,
        name: 'Traffic',
        accessLevel: ROLE_USER
    },
    {
        name: 'Partners',
        icon: 'icon-user',
        url: '/partners',
        accessLevel: USER_LIST,
    },
    {
        name: 'Partner Promo Codes',
        icon: 'icon-list',
        url: '/partner_promo_codes',
        accessLevel: USER_LIST,
    },
    {
        name: 'Mail Subjects',
        icon: 'fa fa-envelope',
        url: '/mail_subjects',
        accessLevel: USER_LIST,
    },
    {
        name: 'Statistics',
        url: '/statistics',
        icon: 'icon-chart',
        accessLevel: STATISTICS_LIST
    },
    {
        name: 'Sources',
        url: '/traffic-sources',
        icon: 'icon-energy',
        accessLevel: USER_LIST,
    },
    {
        name: 'Landings',
        url: '/landings',
        icon: 'icon-layers',
        accessLevel: USER_LIST,
    },
    {
        name: 'Campaigns',
        url: '/campaigns',
        icon: 'icon-speedometer',
        accessLevel: CAMPAIGN_LIST
    },
    {
        name: 'Client Apps',
        url: '/client-apps',
        icon: 'icon-list',
        accessLevel: ROLE_USER
    },
    {
        name: 'App Version Flags',
        url: '/app-version-flags',
        icon: 'icon-list',
        accessLevel: ROLE_USER
    },
    {
        divider: true,
        accessLevel: ROLE_USER
    },
    {
        title: true,
        name: 'Analytics',
        accessLevel: ROLE_USER
    },
    {
        name: 'Rebills',
        icon: 'fa fa-money',
        url: '/rebills',
        accessLevel: REBILLS_LIST
    },
    {
        name: 'Sales Report',
        url: '/sales',
        icon: 'fa fa-money',
        accessLevel: REBILLS_LIST
    },
    {
        name: 'Reports',
        icon: 'fa fa-info',
        url: '/statistics_reports',
        accessLevel: USER_LIST,
    },
    {
        title: true,
        name: 'Includes',
        accessLevel: ROLE_USER
    },
    {
        name: 'Landings Domains',
        url: '/landing-domains',
        icon: 'fa fa-terminal',
        accessLevel: LANDING_DOMAINS_LIST
    },
    {
        name: 'Blacklist Devices',
        url: '/blacklist-devices',
        icon: 'fa fa-exclamation-triangle',
        accessLevel: BLACKLIST_DEVICES_LIST
    },
    {
        name: 'Data Centers',
        url: '/data-centers',
        icon: 'fa fa-server',
        accessLevel: DATA_CENTER_LIST
    },
    {
        name: 'Countries',
        url: '/countries',
        icon: 'fa fa-map',
        accessLevel: COUNTRY_LIST
    },
    {
        name: 'Cities',
        url: '/cities',
        icon: 'fa fa-building',
        accessLevel: CITY_LIST
    },
    {
        name: 'Access Level',
        url: '/access-levels',
        icon: 'fa fa-shield',
        accessLevel: ACCESS_LEVEL_LIST
    },
    {
        title: true,
        name: 'Testing',
        accessLevel: SUPER_ADMIN_ROLE
    },
    {
        name: 'Premium issuance',
        icon: 'icon-energy',
        url: '/premium-issuance',
        accessLevel: SUPER_ADMIN_ROLE
    },
];

const nav = (roles: any) => filteredNav(items(), roles);
export { items, nav };
